module.exports = __webpack_public_path__ + "img/promotores.e8dda2ea.png";